export default __webpack_public_path__ + "static/media/xls_disabled.4bb86912.svg";